import { trans } from '@spotahome/soyuz/client';

import { InfoBanner } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/src/base';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';

import './HowBookingWorks.scss';

const STEPS = [
  {
    number: 1,
    titleKey: 'listing.how_booking_works.step_1.title',
    descriptionKey: 'listing.how_booking_works.step_1.description'
  },
  {
    number: 2,
    titleKey: 'listing.how_booking_works.step_2.title',
    descriptionKey: 'listing.how_booking_works.step_2.description'
  },
  {
    number: 3,
    titleKey: 'listing.how_booking_works.step_3.title',
    descriptionKey: 'listing.how_booking_works.step_3.description'
  }
];

const HowBookingWorks = () => (
  <ListingSectionObservable
    section="howToBook"
    className="how-booking-works"
    bordered={false}
  >
    <div className="how-booking-works__content">
      <ListingTitle role="secondary">
        {trans('listing.how_booking_works.title')}
      </ListingTitle>

      <ol className="how-booking-works__steps">
        {STEPS.map(step => (
          <li key={step.number} className="how-booking-works__step">
            <span className="how-booking-works__step-number">
              {step.number}
            </span>
            <div className="how-booking-works__step-content">
              <h3 className="how-booking-works__step-title">
                {trans(step.titleKey)}
              </h3>
              <p className="how-booking-works__step-description">
                {trans(step.descriptionKey)}
              </p>
            </div>
          </li>
        ))}
      </ol>

      <InfoBanner
        theme="info"
        closable={false}
        icon={<DSIcon name="info" size="m" />}
        content={
          <div className="how-booking-works__banner-content">
            <span className="how-booking-works__banner-title">
              {trans('listing.how_booking_works.banner.title')}
            </span>
            <span className="how-booking-works__banner-description">
              {trans('listing.how_booking_works.banner.description')}
            </span>
          </div>
        }
      />
    </div>
  </ListingSectionObservable>
);

export default HowBookingWorks;
